const lt = {
  appTitle: "Lotto",
  subtitle: "Įveskite žaidimo ID norėdami pradėti arba tęsti",

  // GameSetup fields
  gameIdLabel: "Žaidimo ID",
  gameIdPlaceholder: "pvz. finalas2026",
  playerCountLabel: "Žaidėjų skaičius",
  playerCountHelper: "1–1000, reikalinga tik kuriant naują žaidimą",

  // GameSetup buttons
  btnNewGame: "Naujas žaidimas",
  btnResume: "Tęsti",

  // GameSetup errors
  errGameIdRequired: "Žaidimo ID yra privalomas",
  errPlayerCountRange: "Žaidėjų skaičius turi būti nuo 1 iki 1000",
  errGameExists: (id) =>
    `Žaidimas „${id}" jau egzistuoja. Pasirinkite kitą ID arba tęskite esamą.`,
  errGameNotFound: (id) => `Žaidimas „${id}" nerastas.`,
  errCreateFailed: "Nepavyko sukurti žaidimo. Patikrinkite ryšį.",
  errLoadFailed: "Nepavyko įkelti žaidimo. Patikrinkite ryšį.",

  // Lotto header
  gameLabel: "Žaidimo ID",
  playersLabel: (n) => `${n} žaidėjų`,

  // Lotto buttons
  btnBack: "← Išeiti",
  btnSubmit: "Pateikti",
  btnUndo: "Atšaukti",

  // Lotto input
  drawnNumberLabel: "Ištrauktas skaičius",

  // DataGrid
  colPlayerId: "Žaidėjo ID",
  colTicketNumber: "Bilieto Nr.",
  colNumbersLeft: "Liko skaičių",
  rowsPerPage: "Eilučių puslapyje:",
  displayedRows: ({ from, to, count }) => `${from}–${to} iš ${count}`,
  noRows: "Nėra duomenų",

  // Toast messages
  toastAlreadyDrawn: (n) => `Skaičius ${n} jau buvo ištrauktas`,
  toastInTickets: (n, count, total) =>
    `Skaičius ${n} yra ${count} iš ${total} bilietų`,
  toastNotInTickets: (n) => `Nė vienas bilietas neturi skaičiaus ${n}`,
};

export default lt;
